import React from 'react';

import styles from './title.style';
import { useFont } from '../../hooks/lesson-player.context';
import { ThemedText, ThemedTextProps } from '../themed-text';

interface TitleProps extends ThemedTextProps {
  children: any;
}

export function Title({ children, style, ...props }: TitleProps) {
  const fonts = useFont();
  return (
    <ThemedText
      style={[
        styles.title,
        style,
        {
          ...fonts.primary.bold,
        },
      ]}
      type="onPrimary"
      fontType="primary"
      fontSize="medium"
      {...props}
    >
      {children}
    </ThemedText>
  );
}
